export enum LayerType {
    OSM = 'OSM',
    WMS = 'WMS',
}
